module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Andrei-Stoicescu-9fe797a7e47d53ede4b3cf2a0bad4627.png";